import {
  Box,
  Typography,
} from '@mui/material';
import React from 'react';

import { useSupportPhoneDisplay } from '../utils';
import {
  AXON_LOGO_PATH,
  getErrorCode404,
  getErrorPageTitle,
  getNeedAssistanceMessage,
  SUPPORT_PHONE_TEL
} from '../utils/constants';

const NotFoundPage: React.FC = () => {
  const supportPhoneDisplay = useSupportPhoneDisplay();
  
  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: '#e5e5e5',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2
      }}
    >
      {/* Centered white card */}
      <Box
        sx={{
          bgcolor: 'white',
          borderRadius: 2,
          boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
          p: 4,
          textAlign: 'center',
          maxWidth: 400,
          width: '100%'
        }}
      >
        {/* Axon Logo */}
        <Box
          component="img"
          src={AXON_LOGO_PATH}
          alt="Axon Logo"
          sx={{
            height: 40,
            width: 'auto',
            mb: 3
          }}
        />

        {/* 404 Error Code */}
        <Typography 
          variant="h4"
          sx={{ 
            fontWeight: 600,
            mb: 2,
            color: '#000'
          }}
        >
          {getErrorCode404()}
        </Typography>

        {/* Page Not Found Title */}
        <Typography 
          variant="h6"
          sx={{ 
            fontWeight: 600,
            mb: 2,
            color: '#000'
          }}
        >
          {getErrorPageTitle()}
        </Typography>
        
        {/* Error Description */}
        <Typography 
          variant="body2"
          sx={{ 
            mb: 3,
            color: '#333',
            lineHeight: 1.4
          }}
        >
          {__('The page you\'re looking for doesn\'t exist. Please check the QR code on your Fusus Core device and try scanning again, or $[link].', {
            link: (
              <Box 
                component="span" 
                sx={{ 
                  color: '#1976d2',
                  textDecoration: 'underline',
                  cursor: 'pointer'
                }}
                onClick={() => window.location.href = '/'}
                key="home-link"
              >
                {__('click here')}
              </Box>
            )
          })}
        </Typography>

        {/* Support Contact */}
        <Typography 
          variant="caption"
          sx={{ 
            fontSize: '0.75rem',
            color: '#666',
            fontStyle: 'italic'
          }}
        >
          {getNeedAssistanceMessage()}{' '}
          <Box 
            component="span" 
            sx={{ 
              color: '#1976d2',
              textDecoration: 'underline',
              cursor: 'pointer'
            }}
            onClick={() => window.open(SUPPORT_PHONE_TEL)}
          >
            {supportPhoneDisplay}
          </Box>
          .
        </Typography>
      </Box>
    </Box>
  );
};

export default NotFoundPage; 